import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';

const PER_RENK: Record<string, string> = { 'Günlük': '#ef4444', 'Haftalık': '#f59e0b', 'Aylık': '#3b82f6', 'Yıllık': '#8b5cf6' };

@Component({
  selector: 'bakim-plani-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--bakim-plani" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-parcaciklar"><span class="gc-p gc-p--buyuk" style="--d:9s;--x:10%;--y:20%"></span><span class="gc-p" style="--d:12s;--x:80%;--y:40%"></span><span class="gc-p gc-p--kucuk" style="--d:7s;--x:45%;--y:75%"></span></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">BAKIM PLANI</div>
        <div class="bp-ust">
          <div class="bp-tur gc-baslik-ana">{{ p()?.bakimTuru || 'Bakım' }}</div>
          <div class="bp-per-badge" [style.background]="perRenk()">{{ p()?.periyot || 'Aylık' }}</div>
        </div>
        @if (p()?.notlar) { <div class="bp-notlar">{{ p().notlar }}</div> }
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? 60 : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .gc { --accent: #0369a1; --accent-rgb: 3,105,161; }
    .bp-ust { display: flex; justify-content: space-between; align-items: center; gap: 8px; }
    .bp-tur { font-size: 13px; font-weight: 700; color: var(--py-metin, #e2e8f0); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex: 1; }
    .bp-per-badge { font-size: 8px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; padding: 2px 8px; border-radius: 2px; color: #fff; flex-shrink: 0; }
    .bp-notlar {
      font-size: 10px;
      color: var(--py-metin-ikincil, #64748b);
      line-height: 1.4;
      max-height: 80px;
      overflow-y: auto;
      overflow-x: hidden;
      white-space: normal;
      word-wrap: break-word;
      padding: 2px 4px;
      background: rgba(0,0,0,0.15);
      border-radius: 3px;
    }
    .bp-notlar::-webkit-scrollbar {
      width: 4px;
    }
    .bp-notlar::-webkit-scrollbar-track {
      background: transparent;
    }
    .bp-notlar::-webkit-scrollbar-thumb {
      background: rgba(255,255,255,0.3);
      border-radius: 2px;
    }
    .bp-notlar::-webkit-scrollbar-thumb:hover {
      background: rgba(255,255,255,0.5);
    }
  `],
})
export class BakimPlaniKartComponent extends GameCardBase {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  perRenk = computed(() => PER_RENK[this.p()?.periyot] || '#0369a1');
}
